import * as React from 'react';
import classnames from 'classnames';
import { usePrefixCls } from '../_utils';
import { FormItemProps } from './interface';

const FormItem: React.FC<FormItemProps> = props => {
  const {
    className,
    airlabel,
    required,
    disabled,
    readonly,
    active,
    status,
    message,
    label,
    htmlFor,
    children,
    onClick
  } = props;
  const prefixCls = 'unv-form';
  const comCls = usePrefixCls('form');

  const [focus, setFocus] = React.useState(false);
  const [action, setAction] = React.useState(false);
  const itemRef = React.useRef<HTMLDivElement>(null);

  let airlabelHandles: Record<string, () => void> = {};
  if (airlabel) {
    airlabelHandles = {
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
    };
  }

  React.useEffect(() => {
    if (airlabel && itemRef.current) {
      const inputNode = itemRef.current.querySelector('input') || itemRef.current.querySelector('textarea');
      if (inputNode) {
        if (inputNode.type === 'hidden') {
          const config = { attributes: true };
          const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
              if (mutation.type === 'attributes') {
                setAction(!!inputNode.value);
              }
            });
          });
          observer.observe(inputNode, config);
        } else {
          inputNode.addEventListener('change', () => {
            setAction(!!inputNode.value);
          });
        }

        setTimeout(() => {
          if (inputNode.value) {
            setAction(true);
          }
        }, 0);

        // fix browser autofill
        const startTime = Date.now();
        const initialBgColor = getComputedStyle(inputNode).backgroundColor;
        const timer = setInterval(() => {
          try {
            const currentBgColor = getComputedStyle(inputNode).backgroundColor;
            if (initialBgColor !== currentBgColor) {
              setAction(true);
              clearInterval(timer);
            } else if ((Date.now() - startTime) / 1000 > 3) {
              clearInterval(timer);
            }
          } catch (err) {
            clearInterval(timer);
          }
        }, 100);
      }
    }
  }, [airlabel]);

  const formItemClassName = classnames(
    `${prefixCls}__item`,
    `${comCls}__item`,
    { [`${prefixCls}__item--airlabel`]: airlabel },
    { [`is-${status}`]: status },
    { 'is-required': required },
    { 'is-disabled': disabled },
    { 'is-readonly': readonly },
    { 'is-active': active },
    { 'is-focus': focus },
    { [`${prefixCls}__item--airlabel-action`]: action },
    { 'is-click': typeof onClick === 'function' },
    className,
  );

  return (
    <div
      className={formItemClassName}
      ref={itemRef}
      {...airlabelHandles}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick(props);
        }
      }}
    >
      {Boolean(label) && (
        <div className={`${prefixCls}__item-label`}>
          <label htmlFor={htmlFor}>{label}</label>
        </div>
      )}

      <div className={`${prefixCls}__item-controls`}>
        {children}
        {Boolean(message) && <div className={`${prefixCls}__item-message`}>{message}</div>}
      </div>
    </div>
  );
};

export default FormItem;
